/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Icon_js = require('../Icon.js');
var iconPropTypes = require('../iconPropTypes-25316737.js');
require('@carbon/icon-helpers');
require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _path33, _circle2, _path34, _path35, _circle3, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _circle4, _circle5, _circle6, _circle7, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _circle8, _circle9, _circle10, _circle11, _circle12, _path137, _path138, _path139, _path140, _path141, _circle13, _circle14, _circle15, _path142, _circle16, _circle17, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _circle18, _circle19, _circle20, _circle21, _circle22, _path154, _path155, _path156, _path157, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222;
const CaretLeft = /*#__PURE__*/React__default["default"].forwardRef(function CaretLeft(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 5 8",
      fill: "currentColor",
      ...rest
    }, _path || (_path = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M5 8L0 4 5 0z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 24L10 16 20 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretLeft.propTypes = iconPropTypes.iconPropTypes;
}
const CaretRight = /*#__PURE__*/React__default["default"].forwardRef(function CaretRight(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 5 8",
      fill: "currentColor",
      ...rest
    }, _path3 || (_path3 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M0 0L5 4 0 8z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 8L22 16 12 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretRight.propTypes = iconPropTypes.iconPropTypes;
}
const CaretSort = /*#__PURE__*/React__default["default"].forwardRef(function CaretSort(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M24 24L16 32 8 24zM8 8L16 0 24 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretSort.propTypes = iconPropTypes.iconPropTypes;
}
const CaretSortDown = /*#__PURE__*/React__default["default"].forwardRef(function CaretSortDown(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M24 24L16 32 8 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretSortDown.propTypes = iconPropTypes.iconPropTypes;
}
const CaretSortUp = /*#__PURE__*/React__default["default"].forwardRef(function CaretSortUp(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 8L16 0 24 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretSortUp.propTypes = iconPropTypes.iconPropTypes;
}
const CaretUp = /*#__PURE__*/React__default["default"].forwardRef(function CaretUp(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 8 4",
      fill: "currentColor",
      ...rest
    }, _path8 || (_path8 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M0 4L4 0 8 4z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 20L16 10 24 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretUp.propTypes = iconPropTypes.iconPropTypes;
}
const CarouselHorizontal = /*#__PURE__*/React__default["default"].forwardRef(function CarouselHorizontal(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarouselHorizontal.propTypes = iconPropTypes.iconPropTypes;
}
const CarouselVertical = /*#__PURE__*/React__default["default"].forwardRef(function CarouselVertical(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarouselVertical.propTypes = iconPropTypes.iconPropTypes;
}
const Catalog = /*#__PURE__*/React__default["default"].forwardRef(function Catalog(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Catalog.propTypes = iconPropTypes.iconPropTypes;
}
const CatalogPublish = /*#__PURE__*/React__default["default"].forwardRef(function CatalogPublish(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z"
  })), _path15 || (_path15 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4 c0,1.1,0.9,2,2,2h5V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CatalogPublish.propTypes = iconPropTypes.iconPropTypes;
}
const Categories = /*#__PURE__*/React__default["default"].forwardRef(function Categories(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Categories.propTypes = iconPropTypes.iconPropTypes;
}
const Category = /*#__PURE__*/React__default["default"].forwardRef(function Category(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Category.propTypes = iconPropTypes.iconPropTypes;
}
const CategoryAdd = /*#__PURE__*/React__default["default"].forwardRef(function CategoryAdd(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
  })), _path19 || (_path19 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryAdd.propTypes = iconPropTypes.iconPropTypes;
}
const CategoryAnd = /*#__PURE__*/React__default["default"].forwardRef(function CategoryAnd(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryAnd.propTypes = iconPropTypes.iconPropTypes;
}
const CategoryNew = /*#__PURE__*/React__default["default"].forwardRef(function CategoryNew(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path22 || (_path22 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryNew.propTypes = iconPropTypes.iconPropTypes;
}
const CategoryNewEach = /*#__PURE__*/React__default["default"].forwardRef(function CategoryNewEach(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryNewEach.propTypes = iconPropTypes.iconPropTypes;
}
const Caution = /*#__PURE__*/React__default["default"].forwardRef(function Caution(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path24 || (_path24 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
    })), _path25 || (_path25 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M12.315 12L3.685 12 8 4.088 12.315 12z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
  })), _path27 || (_path27 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.315 12L3.685 12 8 4.088 12.315 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Caution.propTypes = iconPropTypes.iconPropTypes;
}
const CautionInverted = /*#__PURE__*/React__default["default"].forwardRef(function CautionInverted(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path28 || (_path28 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M8 14L2 3 14 3 8 14z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 14L2 3 14 3 8 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CautionInverted.propTypes = iconPropTypes.iconPropTypes;
}
const QCcX = /*#__PURE__*/React__default["default"].forwardRef(function QCcX(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QCcX.propTypes = iconPropTypes.iconPropTypes;
}
const WatsonHealthCdArchive = /*#__PURE__*/React__default["default"].forwardRef(function WatsonHealthCdArchive(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
  })), _path32 || (_path32 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
  })), _circle || (_circle = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCdArchive.propTypes = iconPropTypes.iconPropTypes;
}
const WatsonHealthCdCreateArchive = /*#__PURE__*/React__default["default"].forwardRef(function WatsonHealthCdCreateArchive(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path34 || (_path34 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
  })), _path35 || (_path35 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCdCreateArchive.propTypes = iconPropTypes.iconPropTypes;
}
const WatsonHealthCdCreateExchange = /*#__PURE__*/React__default["default"].forwardRef(function WatsonHealthCdCreateExchange(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path36 || (_path36 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
  })), _path37 || (_path37 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCdCreateExchange.propTypes = iconPropTypes.iconPropTypes;
}
const Cda = /*#__PURE__*/React__default["default"].forwardRef(function Cda(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cda.propTypes = iconPropTypes.iconPropTypes;
}
const CellTower = /*#__PURE__*/React__default["default"].forwardRef(function CellTower(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z"
  })), _path40 || (_path40 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CellTower.propTypes = iconPropTypes.iconPropTypes;
}
const CenterCircle = /*#__PURE__*/React__default["default"].forwardRef(function CenterCircle(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CenterCircle.propTypes = iconPropTypes.iconPropTypes;
}
const CenterSquare = /*#__PURE__*/React__default["default"].forwardRef(function CenterSquare(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CenterSquare.propTypes = iconPropTypes.iconPropTypes;
}
const CenterToFit = /*#__PURE__*/React__default["default"].forwardRef(function CenterToFit(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CenterToFit.propTypes = iconPropTypes.iconPropTypes;
}
const Certificate = /*#__PURE__*/React__default["default"].forwardRef(function Certificate(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
  })), _path45 || (_path45 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Certificate.propTypes = iconPropTypes.iconPropTypes;
}
const CertificateCheck = /*#__PURE__*/React__default["default"].forwardRef(function CertificateCheck(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
  })), _path47 || (_path47 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), _path48 || (_path48 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CertificateCheck.propTypes = iconPropTypes.iconPropTypes;
}
const ChangeCatalog = /*#__PURE__*/React__default["default"].forwardRef(function ChangeCatalog(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z"
  })), _path50 || (_path50 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChangeCatalog.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterDecimal = /*#__PURE__*/React__default["default"].forwardRef(function CharacterDecimal(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 15H23V17H21z"
  })), _path52 || (_path52 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z"
  })), _path53 || (_path53 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterDecimal.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterFraction = /*#__PURE__*/React__default["default"].forwardRef(function CharacterFraction(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
  })), _path55 || (_path55 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.479 15.5H26.521V17.5H4.479z",
    transform: "rotate(-45 15.5 16.5)"
  })), _path56 || (_path56 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterFraction.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterInteger = /*#__PURE__*/React__default["default"].forwardRef(function CharacterInteger(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 21H15V23H5zM15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterInteger.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterLowerCase = /*#__PURE__*/React__default["default"].forwardRef(function CharacterLowerCase(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 13H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 008 13zm0 8H4V19H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterLowerCase.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterNegativeNumber = /*#__PURE__*/React__default["default"].forwardRef(function CharacterNegativeNumber(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
  })), _path62 || (_path62 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 15H15V17H5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterNegativeNumber.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterSentenceCase = /*#__PURE__*/React__default["default"].forwardRef(function CharacterSentenceCase(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterSentenceCase.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterUpperCase = /*#__PURE__*/React__default["default"].forwardRef(function CharacterUpperCase(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM20 12a3.0033 3.0033 0 00-3-3H12V23h5a3.0033 3.0033 0 003-3V18a2.977 2.977 0 00-.78-2A2.9768 2.9768 0 0020 14zm-6-1h3a1.0013 1.0013 0 011 1v2a1.0013 1.0013 0 01-1 1H14zm4 9a1.0009 1.0009 0 01-1 1H14V17h3a1.0009 1.0009 0 011 1zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterUpperCase.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterWholeNumber = /*#__PURE__*/React__default["default"].forwardRef(function CharacterWholeNumber(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28 9H22v2h6v4H24v2h4v4H22v2h6a2.0027 2.0027 0 002-2V11A2.0023 2.0023 0 0028 9zM20 23H12V17a2.002 2.002 0 012-2h4V11H12V9h6a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14v4h6zM2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterWholeNumber.propTypes = iconPropTypes.iconPropTypes;
}
const CharacterPatterns = /*#__PURE__*/React__default["default"].forwardRef(function CharacterPatterns(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 26V17.8281l-3.5859 3.586L1 20l6-6 6 6-1.4141 1.4141L8 17.8281V26H18v2H8A2.0024 2.0024 0 016 26zM30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22zM26 6v8.1719l3.5859-3.586L31 12l-6 6-6-6 1.4141-1.4141L24 14.1719V6H14V4H24A2.0024 2.0024 0 0126 6zM8 2H3V4H8V6H4A2 2 0 002 8v2a2 2 0 002 2h6V4A2.0023 2.0023 0 008 2zm0 8H4V8H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterPatterns.propTypes = iconPropTypes.iconPropTypes;
}
const ChargingStation = /*#__PURE__*/React__default["default"].forwardRef(function ChargingStation(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z"
  })), _path69 || (_path69 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChargingStation.propTypes = iconPropTypes.iconPropTypes;
}
const ChargingStationFilled = /*#__PURE__*/React__default["default"].forwardRef(function ChargingStationFilled(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z"
  })), _path71 || (_path71 = /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "none",
    d: "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChargingStationFilled.propTypes = iconPropTypes.iconPropTypes;
}
const Chart_3D = /*#__PURE__*/React__default["default"].forwardRef(function Chart_3D(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Chart_3D.propTypes = iconPropTypes.iconPropTypes;
}
const ChartArea = /*#__PURE__*/React__default["default"].forwardRef(function ChartArea(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartArea.propTypes = iconPropTypes.iconPropTypes;
}
const ChartAreaSmooth = /*#__PURE__*/React__default["default"].forwardRef(function ChartAreaSmooth(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartAreaSmooth.propTypes = iconPropTypes.iconPropTypes;
}
const ChartAreaStepper = /*#__PURE__*/React__default["default"].forwardRef(function ChartAreaStepper(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartAreaStepper.propTypes = iconPropTypes.iconPropTypes;
}
const ChartAverage = /*#__PURE__*/React__default["default"].forwardRef(function ChartAverage(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z"
  })), _path77 || (_path77 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path78 || (_path78 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 15H10V17H8zM12 15H14V17H12zM20 15H22V17H20zM24 15H26V17H24zM28 15H30V17H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartAverage.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBar = /*#__PURE__*/React__default["default"].forwardRef(function ChartBar(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBar.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBarFloating = /*#__PURE__*/React__default["default"].forwardRef(function ChartBarFloating(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28 24H14V16H28zM16 22H26V18H16zM26 12H8V4H26zM10 10H24V6H10z"
  })), _path81 || (_path81 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarFloating.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBarOverlay = /*#__PURE__*/React__default["default"].forwardRef(function ChartBarOverlay(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarOverlay.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBarStacked = /*#__PURE__*/React__default["default"].forwardRef(function ChartBarStacked(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarStacked.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBarTarget = /*#__PURE__*/React__default["default"].forwardRef(function ChartBarTarget(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28 17H30V25H28zM20 5H22V13H20z"
  })), _path85 || (_path85 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarTarget.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBubble = /*#__PURE__*/React__default["default"].forwardRef(function ChartBubble(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _path87 || (_path87 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 16a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4zM21 6a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6zM24.5 21A1.5 1.5 0 1123 22.5 1.5 1.5 0 0124.5 21m0-2A3.5 3.5 0 1028 22.5 3.5 3.5 0 0024.5 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBubble.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBubblePacked = /*#__PURE__*/React__default["default"].forwardRef(function ChartBubblePacked(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBubblePacked.propTypes = iconPropTypes.iconPropTypes;
}
const ChartBullet = /*#__PURE__*/React__default["default"].forwardRef(function ChartBullet(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30 22H16V21H14v1H2v6H14v1h2V28H30zM4 26V24H14v2zm24 0H16V24H28zM30 13H24V12H22v1H2v6H22v1h2V19h6zM4 17V15H22v2zm24 0H24V15h4zM30 4H10V3H8V4H2v6H8v1h2V10H30zM4 8V6H8V8zM28 8H10V6H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBullet.propTypes = iconPropTypes.iconPropTypes;
}
const ChartCandlestick = /*#__PURE__*/React__default["default"].forwardRef(function ChartCandlestick(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26 10H24V6H22v4H20V22h2v4h2V22h2zM24 20H22V12h2zM14 8H12V4H10V8H8V18h2v4h2V18h2zm-2 8H10V10h2z"
  })), _path91 || (_path91 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartCandlestick.propTypes = iconPropTypes.iconPropTypes;
}
const ChartClusterBar = /*#__PURE__*/React__default["default"].forwardRef(function ChartClusterBar(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _path93 || (_path93 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 16H12V26H10zM7 22H9V26H7zM26 8H28V26H26zM23 14H25V26H23z"
  })), _path94 || (_path94 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 12H17V26H15z",
    transform: "rotate(-180 16 19)"
  })), _path95 || (_path95 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 18H20V26H18z",
    transform: "rotate(-180 19 22)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartClusterBar.propTypes = iconPropTypes.iconPropTypes;
}
const ChartColumn = /*#__PURE__*/React__default["default"].forwardRef(function ChartColumn(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartColumn.propTypes = iconPropTypes.iconPropTypes;
}
const ChartColumnFloating = /*#__PURE__*/React__default["default"].forwardRef(function ChartColumnFloating(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28 22H20V4h8zm-6-2h4V6H22zM16 24H8V10h8zm-6-2h4V12H10z"
  })), _path98 || (_path98 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartColumnFloating.propTypes = iconPropTypes.iconPropTypes;
}
const ChartColumnTarget = /*#__PURE__*/React__default["default"].forwardRef(function ChartColumnTarget(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27 28V6H19V28H15V14H7V28H4V2H2V28a2 2 0 002 2H30V28zM13 28H9V16h4zm12 0H21V8h4zM19 2H27V4H19z"
  })), _path100 || (_path100 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 10H15V12H7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartColumnTarget.propTypes = iconPropTypes.iconPropTypes;
}
const ChartCombo = /*#__PURE__*/React__default["default"].forwardRef(function ChartCombo(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z"
  })), _path102 || (_path102 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartCombo.propTypes = iconPropTypes.iconPropTypes;
}
const ChartComboStacked = /*#__PURE__*/React__default["default"].forwardRef(function ChartComboStacked(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z"
  })), _path104 || (_path104 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartComboStacked.propTypes = iconPropTypes.iconPropTypes;
}
const ChartCustom = /*#__PURE__*/React__default["default"].forwardRef(function ChartCustom(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path106 || (_path106 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 15H21V17H17z",
    transform: "rotate(-90 19 16)"
  })), _path107 || (_path107 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 14H18V16H12z",
    transform: "rotate(-90 15 15)"
  })), _path108 || (_path108 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 12H16V14H6z",
    transform: "rotate(-90 11 13)"
  })), _path109 || (_path109 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartCustom.propTypes = iconPropTypes.iconPropTypes;
}
const ChartDualYAxis = /*#__PURE__*/React__default["default"].forwardRef(function ChartDualYAxis(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m28,2v5.7222l-7.5317,6.9521L12.3818,6.5879c-.3918-.3911-.9111-.5918-1.4302-.5879-.4644.0034-.9285.1714-1.301.4976l-5.6506,4.9443V2h-2v26c0,1.1025.8972,2,2,2h24c1.1028,0,2-.8975,2-2V2h-2Zm0,8.4438v11.7622l-6.1165-6.1162,6.1165-5.646Zm-17.0322-2.4414l8.0298,8.0298-3.2141,2.9668-3.4148-3.415c-.3711-.3706-.8564-.5674-1.3479-.584s-.9885.1475-1.3833.4932l-5.6375,4.9326v-6.3262l6.9678-6.0972Zm-6.9678,19.9976v-4.9165l6.9546-6.085,3.4146,3.4146c.3809.3809.8755.5771,1.374.5869s1.0007-.166,1.3967-.5312l3.2729-3.0215,7.5872,7.5869v2.9658H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartDualYAxis.propTypes = iconPropTypes.iconPropTypes;
}
const ChartErrorBar = /*#__PURE__*/React__default["default"].forwardRef(function ChartErrorBar(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartErrorBar.propTypes = iconPropTypes.iconPropTypes;
}
const ChartErrorBarAlt = /*#__PURE__*/React__default["default"].forwardRef(function ChartErrorBarAlt(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 10V8H8v2h2v4.1836a2.983 2.983 0 000 5.6328V24H8v2h6V24H12V19.8164a2.983 2.983 0 000-5.6328V10zM26 6V4H20V6h2V8.1836a2.983 2.983 0 000 5.6328V18H20v2h6V18H24V13.8164a2.983 2.983 0 000-5.6328V6z"
  })), _path113 || (_path113 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartErrorBarAlt.propTypes = iconPropTypes.iconPropTypes;
}
const ChartEvaluation = /*#__PURE__*/React__default["default"].forwardRef(function ChartEvaluation(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M25.672 6.207H29.915V8.206H25.672z",
    transform: "rotate(-45.02 27.793 7.207)"
  })), _path115 || (_path115 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z"
  })), _path116 || (_path116 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartEvaluation.propTypes = iconPropTypes.iconPropTypes;
}
const ChartHighLow = /*#__PURE__*/React__default["default"].forwardRef(function ChartHighLow(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8zM27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z"
  })), _path118 || (_path118 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartHighLow.propTypes = iconPropTypes.iconPropTypes;
}
const ChartHistogram = /*#__PURE__*/React__default["default"].forwardRef(function ChartHistogram(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartHistogram.propTypes = iconPropTypes.iconPropTypes;
}
const ChartLine = /*#__PURE__*/React__default["default"].forwardRef(function ChartLine(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLine.propTypes = iconPropTypes.iconPropTypes;
}
const ChartLineData = /*#__PURE__*/React__default["default"].forwardRef(function ChartLineData(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLineData.propTypes = iconPropTypes.iconPropTypes;
}
const ChartLineSmooth = /*#__PURE__*/React__default["default"].forwardRef(function ChartLineSmooth(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLineSmooth.propTypes = iconPropTypes.iconPropTypes;
}
const ChartLogisticRegression = /*#__PURE__*/React__default["default"].forwardRef(function ChartLogisticRegression(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "20",
    cy: "22",
    r: "2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "14",
    cy: "6",
    r: "2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "8",
    cy: "6",
    r: "2"
  })), _path123 || (_path123 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m8.2339,24c3.8799,0,7.311-2.4731,8.5383-6.1543l2.353-7.0591c.9543-2.8628,3.6233-4.7866,6.6409-4.7866h4.2339v-2h-4.2339c-3.8799,0-7.311,2.4731-8.5383,6.1543l-2.353,7.0591c-.9543,2.8628-3.6233,4.7866-6.6409,4.7866h-4.2339V2h-2v26c0,1.1025.897,2,2,2h26v-2H4v-4h4.2339Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLogisticRegression.propTypes = iconPropTypes.iconPropTypes;
}
const ChartMarimekko = /*#__PURE__*/React__default["default"].forwardRef(function ChartMarimekko(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMarimekko.propTypes = iconPropTypes.iconPropTypes;
}
const ChartMaximum = /*#__PURE__*/React__default["default"].forwardRef(function ChartMaximum(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 6H10V8H8zM12 6H14V8H12zM20 6H22V8H20zM24 6H26V8H24zM28 6H30V8H28z"
  })), _path126 || (_path126 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMaximum.propTypes = iconPropTypes.iconPropTypes;
}
const ChartMedian = /*#__PURE__*/React__default["default"].forwardRef(function ChartMedian(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 22H18V24H16z",
    transform: "rotate(-90 17 23)"
  })), _path128 || (_path128 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path129 || (_path129 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
  })), _path130 || (_path130 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 6H18V8H16z",
    transform: "rotate(-90 17 7)"
  })), _path131 || (_path131 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 2H18V4H16z",
    transform: "rotate(-90 17 3)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMedian.propTypes = iconPropTypes.iconPropTypes;
}
const ChartMinimum = /*#__PURE__*/React__default["default"].forwardRef(function ChartMinimum(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path133 || (_path133 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 24H10V26H8zM12 24H14V26H12zM20 24H22V26H20zM24 24H26V26H24zM28 24H30V26H28z"
  })), _path134 || (_path134 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMinimum.propTypes = iconPropTypes.iconPropTypes;
}
const ChartMultiLine = /*#__PURE__*/React__default["default"].forwardRef(function ChartMultiLine(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMultiLine.propTypes = iconPropTypes.iconPropTypes;
}
const ChartMultitype = /*#__PURE__*/React__default["default"].forwardRef(function ChartMultitype(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28 22H30V30H28zM24 18H26V30H24zM20 26H22V30H20zM9 16a7 7 0 107 7A7.0078 7.0078 0 009 16zm4.8989 6H10V18.1011A5.0145 5.0145 0 0113.8989 22zM9 28a5 5 0 01-1-9.8989V22a2 2 0 002 2h3.8989A5.0081 5.0081 0 019 28zM22.5352 12l4-6H30V4H25.4648l-4 6H18V2H16V14a2 2 0 002 2H30V14H18V12z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "11",
    cy: "7",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "9",
    cy: "11",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7",
    cy: "5",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "5",
    cy: "9",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "3",
    cy: "13",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMultitype.propTypes = iconPropTypes.iconPropTypes;
}
const ChartNetwork = /*#__PURE__*/React__default["default"].forwardRef(function ChartNetwork(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartNetwork.propTypes = iconPropTypes.iconPropTypes;
}
const ChartParallel = /*#__PURE__*/React__default["default"].forwardRef(function ChartParallel(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartParallel.propTypes = iconPropTypes.iconPropTypes;
}
const ChartPie = /*#__PURE__*/React__default["default"].forwardRef(function ChartPie(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPie.propTypes = iconPropTypes.iconPropTypes;
}
const ChartPlanningWaterfall = /*#__PURE__*/React__default["default"].forwardRef(function ChartPlanningWaterfall(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m29,8c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v7h-2V3c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v12h-2V5c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v10H3v12c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-10h2v5c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-5h2v12c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-12h4v-9ZM7,26h-2v-9h2v9Zm8-5h-2v-4h2v4Zm2-6V4h2v11h-2Zm10,0h-2v-6h2v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPlanningWaterfall.propTypes = iconPropTypes.iconPropTypes;
}
const ChartPoint = /*#__PURE__*/React__default["default"].forwardRef(function ChartPoint(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "9",
    cy: "6",
    r: "3"
  })), _circle14 || (_circle14 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "9",
    cy: "22",
    r: "3"
  })), _circle15 || (_circle15 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "18",
    cy: "14",
    r: "3"
  })), _path142 || (_path142 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "27",
    cy: "6",
    r: "3"
  })), _circle17 || (_circle17 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "27",
    cy: "22",
    r: "3"
  })), _path143 || (_path143 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27 17a3 3 0 113-3A3.0033 3.0033 0 0127 17zm0-4a1 1 0 101 1A1.001 1.001 0 0027 13zM18 26a3 3 0 113-3A3.0033 3.0033 0 0118 26zm0-4a1 1 0 101 1A1.001 1.001 0 0018 22zM18 8a3 3 0 113-3A3.0033 3.0033 0 0118 8zm0-4a1 1 0 101 1A1.001 1.001 0 0018 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPoint.propTypes = iconPropTypes.iconPropTypes;
}
const ChartPopulation = /*#__PURE__*/React__default["default"].forwardRef(function ChartPopulation(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPopulation.propTypes = iconPropTypes.iconPropTypes;
}
const ChartRadar = /*#__PURE__*/React__default["default"].forwardRef(function ChartRadar(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRadar.propTypes = iconPropTypes.iconPropTypes;
}
const ChartRadial = /*#__PURE__*/React__default["default"].forwardRef(function ChartRadial(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
  })), _path147 || (_path147 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
  })), _path148 || (_path148 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRadial.propTypes = iconPropTypes.iconPropTypes;
}
const ChartRelationship = /*#__PURE__*/React__default["default"].forwardRef(function ChartRelationship(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRelationship.propTypes = iconPropTypes.iconPropTypes;
}
const ChartRing = /*#__PURE__*/React__default["default"].forwardRef(function ChartRing(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRing.propTypes = iconPropTypes.iconPropTypes;
}
const ChartRiver = /*#__PURE__*/React__default["default"].forwardRef(function ChartRiver(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRiver.propTypes = iconPropTypes.iconPropTypes;
}
const ChartRose = /*#__PURE__*/React__default["default"].forwardRef(function ChartRose(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRose.propTypes = iconPropTypes.iconPropTypes;
}
const ChartScatter = /*#__PURE__*/React__default["default"].forwardRef(function ChartScatter(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "10",
    cy: "22",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "14",
    cy: "15",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "22",
    cy: "15",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "26",
    cy: "6",
    r: "2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "14",
    cy: "8",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartScatter.propTypes = iconPropTypes.iconPropTypes;
}
const ChartSpiral = /*#__PURE__*/React__default["default"].forwardRef(function ChartSpiral(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartSpiral.propTypes = iconPropTypes.iconPropTypes;
}
const ChartStacked = /*#__PURE__*/React__default["default"].forwardRef(function ChartStacked(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartStacked.propTypes = iconPropTypes.iconPropTypes;
}
const ChartStepper = /*#__PURE__*/React__default["default"].forwardRef(function ChartStepper(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartStepper.propTypes = iconPropTypes.iconPropTypes;
}
const ChartSunburst = /*#__PURE__*/React__default["default"].forwardRef(function ChartSunburst(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartSunburst.propTypes = iconPropTypes.iconPropTypes;
}
const ChartTSne = /*#__PURE__*/React__default["default"].forwardRef(function ChartTSne(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle23 || (_circle23 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "10",
    cy: "20",
    r: "2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "10",
    cy: "14",
    r: "2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "22",
    cy: "6",
    r: "2"
  })), _circle28 || (_circle28 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "28",
    cy: "10",
    r: "2"
  })), _circle29 || (_circle29 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "20",
    cy: "12",
    r: "2"
  })), _circle30 || (_circle30 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "28",
    cy: "22",
    r: "2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "26",
    cy: "28",
    r: "2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "20",
    cy: "26",
    r: "2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "22",
    cy: "20",
    r: "2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "4",
    cy: "24",
    r: "2"
  })), _circle36 || (_circle36 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartTSne.propTypes = iconPropTypes.iconPropTypes;
}
const ChartTreemap = /*#__PURE__*/React__default["default"].forwardRef(function ChartTreemap(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartTreemap.propTypes = iconPropTypes.iconPropTypes;
}
const ChartVennDiagram = /*#__PURE__*/React__default["default"].forwardRef(function ChartVennDiagram(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartVennDiagram.propTypes = iconPropTypes.iconPropTypes;
}
const ChartViolinPlot = /*#__PURE__*/React__default["default"].forwardRef(function ChartViolinPlot(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _path161 || (_path161 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartViolinPlot.propTypes = iconPropTypes.iconPropTypes;
}
const ChartWaterfall = /*#__PURE__*/React__default["default"].forwardRef(function ChartWaterfall(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
  })), _path163 || (_path163 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 4H16V18H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartWaterfall.propTypes = iconPropTypes.iconPropTypes;
}
const ChartWinLoss = /*#__PURE__*/React__default["default"].forwardRef(function ChartWinLoss(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartWinLoss.propTypes = iconPropTypes.iconPropTypes;
}
const Chat = /*#__PURE__*/React__default["default"].forwardRef(function Chat(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
  })), _path166 || (_path166 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 10H24V12H8zM8 16H18V18H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Chat.propTypes = iconPropTypes.iconPropTypes;
}
const ChatLaunch = /*#__PURE__*/React__default["default"].forwardRef(function ChatLaunch(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4zM28 16v4a1.9965 1.9965 0 01-2 2H20l-4 7 1.7358 1 3.4288-6H26a3.9992 3.9992 0 004-4V16zM4 20V8A1.9965 1.9965 0 016 6H18V4H6A3.9986 3.9986 0 002 8V20a3.9992 3.9992 0 004 4h9V22H6A1.9965 1.9965 0 014 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatLaunch.propTypes = iconPropTypes.iconPropTypes;
}
const ChatOff = /*#__PURE__*/React__default["default"].forwardRef(function ChatOff(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M28 8V21h2V8a3.9986 3.9986 0 00-4-4H8.2429l2 2H26A1.9965 1.9965 0 0128 8zM30 28.5859L3.4141 2 2 3.4141 3.5039 4.918A3.9181 3.9181 0 002 8V20a3.9992 3.9992 0 004 4h6V22H6a1.9965 1.9965 0 01-2-2V8a1.9814 1.9814 0 01.9194-1.6665L20.5859 22H17l-4 7 1.7358 1 3.4288-6h4.4213l6 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatOff.propTypes = iconPropTypes.iconPropTypes;
}
const ChatOperational = /*#__PURE__*/React__default["default"].forwardRef(function ChatOperational(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
  })), _path170 || (_path170 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414zM10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
  })), _path171 || (_path171 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatOperational.propTypes = iconPropTypes.iconPropTypes;
}
const ChatBot = /*#__PURE__*/React__default["default"].forwardRef(function ChatBot(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
  })), _path173 || (_path173 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatBot.propTypes = iconPropTypes.iconPropTypes;
}
const Checkbox = /*#__PURE__*/React__default["default"].forwardRef(function Checkbox(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Checkbox.propTypes = iconPropTypes.iconPropTypes;
}
const CheckboxChecked = /*#__PURE__*/React__default["default"].forwardRef(function CheckboxChecked(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), _path176 || (_path176 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxChecked.propTypes = iconPropTypes.iconPropTypes;
}
const CheckboxCheckedFilled = /*#__PURE__*/React__default["default"].forwardRef(function CheckboxCheckedFilled(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
  })), _path178 || (_path178 = /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "none",
    d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxCheckedFilled.propTypes = iconPropTypes.iconPropTypes;
}
const CheckboxIndeterminate = /*#__PURE__*/React__default["default"].forwardRef(function CheckboxIndeterminate(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 14H22V18H10z"
  })), _path180 || (_path180 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxIndeterminate.propTypes = iconPropTypes.iconPropTypes;
}
const CheckboxIndeterminateFilled = /*#__PURE__*/React__default["default"].forwardRef(function CheckboxIndeterminateFilled(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
  })), _path182 || (_path182 = /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "none",
    d: "M22,18H10V14H22Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxIndeterminateFilled.propTypes = iconPropTypes.iconPropTypes;
}
const Checkmark = /*#__PURE__*/React__default["default"].forwardRef(function Checkmark(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path183 || (_path183 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
    })), _path184 || (_path184 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path185 || (_path185 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Checkmark.propTypes = iconPropTypes.iconPropTypes;
}
const CheckmarkFilled = /*#__PURE__*/React__default["default"].forwardRef(function CheckmarkFilled(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path187 || (_path187 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
    })), _path188 || (_path188 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path189 || (_path189 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
    })), _path190 || (_path190 = /*#__PURE__*/React__default["default"].createElement("path", {
      fill: "none",
      d: "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path191 || (_path191 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
    })), _path192 || (_path192 = /*#__PURE__*/React__default["default"].createElement("path", {
      fill: "none",
      d: "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
  })), _path194 || (_path194 = /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "none",
    d: "M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkFilled.propTypes = iconPropTypes.iconPropTypes;
}
const CheckmarkFilledError = /*#__PURE__*/React__default["default"].forwardRef(function CheckmarkFilledError(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), _path196 || (_path196 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), _path197 || (_path197 = /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "none",
    d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkFilledError.propTypes = iconPropTypes.iconPropTypes;
}
const CheckmarkFilledWarning = /*#__PURE__*/React__default["default"].forwardRef(function CheckmarkFilledWarning(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), _path199 || (_path199 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), _path200 || (_path200 = /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "none",
    d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkFilledWarning.propTypes = iconPropTypes.iconPropTypes;
}
const CheckmarkOutline = /*#__PURE__*/React__default["default"].forwardRef(function CheckmarkOutline(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
  })), _path202 || (_path202 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkOutline.propTypes = iconPropTypes.iconPropTypes;
}
const CheckmarkOutlineError = /*#__PURE__*/React__default["default"].forwardRef(function CheckmarkOutlineError(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), _path204 || (_path204 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkOutlineError.propTypes = iconPropTypes.iconPropTypes;
}
const CheckmarkOutlineWarning = /*#__PURE__*/React__default["default"].forwardRef(function CheckmarkOutlineWarning(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), _path206 || (_path206 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkOutlineWarning.propTypes = iconPropTypes.iconPropTypes;
}
const Chemistry = /*#__PURE__*/React__default["default"].forwardRef(function Chemistry(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Chemistry.propTypes = iconPropTypes.iconPropTypes;
}
const ChemistryReference = /*#__PURE__*/React__default["default"].forwardRef(function ChemistryReference(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path209 || (_path209 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChemistryReference.propTypes = iconPropTypes.iconPropTypes;
}
const ChevronDown = /*#__PURE__*/React__default["default"].forwardRef(function ChevronDown(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 10 6",
      fill: "currentColor",
      ...rest
    }, _path210 || (_path210 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path211 || (_path211 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronDown.propTypes = iconPropTypes.iconPropTypes;
}
const ChevronDownOutline = /*#__PURE__*/React__default["default"].forwardRef(function ChevronDownOutline(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.4142 12.5858L16 19.1714 22.5858 12.5858 24 14 16 22 8 14 9.4142 12.5858z"
  })), _path214 || (_path214 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m30,16c0,7.7197-6.2803,14-14,14S2,23.7197,2,16,8.2803,2,16,2s14,6.2803,14,14Zm-26,0c0,6.6167,5.3833,12,12,12s12-5.3833,12-12-5.3833-12-12-12S4,9.3833,4,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronDownOutline.propTypes = iconPropTypes.iconPropTypes;
}
const ChevronLeft = /*#__PURE__*/React__default["default"].forwardRef(function ChevronLeft(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 6 10",
      fill: "currentColor",
      ...rest
    }, _path215 || (_path215 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path216 || (_path216 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronLeft.propTypes = iconPropTypes.iconPropTypes;
}
const ChevronMini = /*#__PURE__*/React__default["default"].forwardRef(function ChevronMini(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path218 || (_path218 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M15 9L15 15 9 15z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M31 19L31 31 19 31 31 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronMini.propTypes = iconPropTypes.iconPropTypes;
}
const ChevronRight = /*#__PURE__*/React__default["default"].forwardRef(function ChevronRight(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 6 10",
      fill: "currentColor",
      ...rest
    }, _path220 || (_path220 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path221 || (_path221 = /*#__PURE__*/React__default["default"].createElement("path", {
      d: "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
    })), children);
  }
  return /*#__PURE__*/React__default["default"].createElement(Icon_js, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronRight.propTypes = iconPropTypes.iconPropTypes;
}

exports.CaretLeft = CaretLeft;
exports.CaretRight = CaretRight;
exports.CaretSort = CaretSort;
exports.CaretSortDown = CaretSortDown;
exports.CaretSortUp = CaretSortUp;
exports.CaretUp = CaretUp;
exports.CarouselHorizontal = CarouselHorizontal;
exports.CarouselVertical = CarouselVertical;
exports.Catalog = Catalog;
exports.CatalogPublish = CatalogPublish;
exports.Categories = Categories;
exports.Category = Category;
exports.CategoryAdd = CategoryAdd;
exports.CategoryAnd = CategoryAnd;
exports.CategoryNew = CategoryNew;
exports.CategoryNewEach = CategoryNewEach;
exports.Caution = Caution;
exports.CautionInverted = CautionInverted;
exports.Cda = Cda;
exports.CellTower = CellTower;
exports.CenterCircle = CenterCircle;
exports.CenterSquare = CenterSquare;
exports.CenterToFit = CenterToFit;
exports.Certificate = Certificate;
exports.CertificateCheck = CertificateCheck;
exports.ChangeCatalog = ChangeCatalog;
exports.CharacterDecimal = CharacterDecimal;
exports.CharacterFraction = CharacterFraction;
exports.CharacterInteger = CharacterInteger;
exports.CharacterLowerCase = CharacterLowerCase;
exports.CharacterNegativeNumber = CharacterNegativeNumber;
exports.CharacterPatterns = CharacterPatterns;
exports.CharacterSentenceCase = CharacterSentenceCase;
exports.CharacterUpperCase = CharacterUpperCase;
exports.CharacterWholeNumber = CharacterWholeNumber;
exports.ChargingStation = ChargingStation;
exports.ChargingStationFilled = ChargingStationFilled;
exports.ChartArea = ChartArea;
exports.ChartAreaSmooth = ChartAreaSmooth;
exports.ChartAreaStepper = ChartAreaStepper;
exports.ChartAverage = ChartAverage;
exports.ChartBar = ChartBar;
exports.ChartBarFloating = ChartBarFloating;
exports.ChartBarOverlay = ChartBarOverlay;
exports.ChartBarStacked = ChartBarStacked;
exports.ChartBarTarget = ChartBarTarget;
exports.ChartBubble = ChartBubble;
exports.ChartBubblePacked = ChartBubblePacked;
exports.ChartBullet = ChartBullet;
exports.ChartCandlestick = ChartCandlestick;
exports.ChartClusterBar = ChartClusterBar;
exports.ChartColumn = ChartColumn;
exports.ChartColumnFloating = ChartColumnFloating;
exports.ChartColumnTarget = ChartColumnTarget;
exports.ChartCombo = ChartCombo;
exports.ChartComboStacked = ChartComboStacked;
exports.ChartCustom = ChartCustom;
exports.ChartDualYAxis = ChartDualYAxis;
exports.ChartErrorBar = ChartErrorBar;
exports.ChartErrorBarAlt = ChartErrorBarAlt;
exports.ChartEvaluation = ChartEvaluation;
exports.ChartHighLow = ChartHighLow;
exports.ChartHistogram = ChartHistogram;
exports.ChartLine = ChartLine;
exports.ChartLineData = ChartLineData;
exports.ChartLineSmooth = ChartLineSmooth;
exports.ChartLogisticRegression = ChartLogisticRegression;
exports.ChartMarimekko = ChartMarimekko;
exports.ChartMaximum = ChartMaximum;
exports.ChartMedian = ChartMedian;
exports.ChartMinimum = ChartMinimum;
exports.ChartMultiLine = ChartMultiLine;
exports.ChartMultitype = ChartMultitype;
exports.ChartNetwork = ChartNetwork;
exports.ChartParallel = ChartParallel;
exports.ChartPie = ChartPie;
exports.ChartPlanningWaterfall = ChartPlanningWaterfall;
exports.ChartPoint = ChartPoint;
exports.ChartPopulation = ChartPopulation;
exports.ChartRadar = ChartRadar;
exports.ChartRadial = ChartRadial;
exports.ChartRelationship = ChartRelationship;
exports.ChartRing = ChartRing;
exports.ChartRiver = ChartRiver;
exports.ChartRose = ChartRose;
exports.ChartScatter = ChartScatter;
exports.ChartSpiral = ChartSpiral;
exports.ChartStacked = ChartStacked;
exports.ChartStepper = ChartStepper;
exports.ChartSunburst = ChartSunburst;
exports.ChartTSne = ChartTSne;
exports.ChartTreemap = ChartTreemap;
exports.ChartVennDiagram = ChartVennDiagram;
exports.ChartViolinPlot = ChartViolinPlot;
exports.ChartWaterfall = ChartWaterfall;
exports.ChartWinLoss = ChartWinLoss;
exports.Chart_3D = Chart_3D;
exports.Chat = Chat;
exports.ChatBot = ChatBot;
exports.ChatLaunch = ChatLaunch;
exports.ChatOff = ChatOff;
exports.ChatOperational = ChatOperational;
exports.Checkbox = Checkbox;
exports.CheckboxChecked = CheckboxChecked;
exports.CheckboxCheckedFilled = CheckboxCheckedFilled;
exports.CheckboxIndeterminate = CheckboxIndeterminate;
exports.CheckboxIndeterminateFilled = CheckboxIndeterminateFilled;
exports.Checkmark = Checkmark;
exports.CheckmarkFilled = CheckmarkFilled;
exports.CheckmarkFilledError = CheckmarkFilledError;
exports.CheckmarkFilledWarning = CheckmarkFilledWarning;
exports.CheckmarkOutline = CheckmarkOutline;
exports.CheckmarkOutlineError = CheckmarkOutlineError;
exports.CheckmarkOutlineWarning = CheckmarkOutlineWarning;
exports.Chemistry = Chemistry;
exports.ChemistryReference = ChemistryReference;
exports.ChevronDown = ChevronDown;
exports.ChevronDownOutline = ChevronDownOutline;
exports.ChevronLeft = ChevronLeft;
exports.ChevronMini = ChevronMini;
exports.ChevronRight = ChevronRight;
exports.QCcX = QCcX;
exports.WatsonHealthCdArchive = WatsonHealthCdArchive;
exports.WatsonHealthCdCreateArchive = WatsonHealthCdCreateArchive;
exports.WatsonHealthCdCreateExchange = WatsonHealthCdCreateExchange;
